import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";
import { Icon, type IconName } from "./Icon";

export type PillTone = "plain" | "good" | "warn" | "bad" | "wine" | "brass" | "line" | "livep";

/** A small status word (`.pill`), with a dot when it is a state and a pulse when someone is watching now. */
export function Pill({ tone = "plain", dot = false, watching = false, icon, children, className }: {
  tone?: PillTone;
  dot?: boolean;
  watching?: boolean;
  icon?: IconName;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={cx("pill", tone !== "plain" && tone, watching && "watch", className)}>
      {dot || watching ? <i /> : null}
      {icon ? <Icon name={icon} /> : null}
      {children}
    </span>
  );
}

interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  on?: boolean;
  /** A count after the words. */
  count?: number | string;
  children: ReactNode;
}

/** A filter you press (`.chip`); `on` is the chosen one, and is announced as pressed. */
export function Chip({ on = false, count, children, className, type = "button", ...rest }: ChipProps) {
  return (
    <button type={type} className={cx("chip", on && "on", className)} aria-pressed={on} {...rest}>
      {children}
      {count !== undefined ? <span className="n">{count}</span> : null}
    </button>
  );
}

/** A tag on a person (`.tag`); Flashroom's own tags are drawn outlined. */
export function Tag({ system = false, children, className }: { system?: boolean; children: ReactNode; className?: string }) {
  return <span className={cx("tag", system && "tsys", className)}>{children}</span>;
}
